import { h } from 'preact'

const Icon = ({ color, status }: IconProps) => (
  <svg
    viewBox="0 0 12 8"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    style={`fill: ${color}; pointer-events: none;`}
  >
    {status ? (
      <path d="M10.198 0L6 4.303 1.803 0 0 1.848 6 8l6-6.152z"></path>
      ) : (
      <path d="M1.802 8L6 3.697 10.197 8 12 6.152 6 0 0 6.152z"></path>
    )}
  </svg>
)

export default Icon

export interface IconProps {
  color: string
  status: boolean
}
